import React from 'react'
import { Input as AntTextarea } from 'antd'
import clsx from 'clsx'
import { TextAreaProps as AntTextAreaProps } from 'antd/lib/input/TextArea'

import s from './TextArea.module.css'

const Component = AntTextarea.TextArea

export type TextAreaProps = AntTextAreaProps & {
  showWordCount?: boolean
  updatePosition?: (val: number) => void
  dataId?: string
  helperText?: string
  error?: string
}

export const TextArea: React.FC<TextAreaProps> = ({
  disabled,
  rows,
  maxLength,
  value,
  name,
  showCount,
  onChange,
  onBlur,
  placeholder,
  onPressEnter,
  onFocus,
  autoSize,
  className,
  updatePosition,
  dataId,
  itemRef,
  helperText,
  error
}) => {
  const supportingText = error ?? helperText

  return (
    <div className={s.wrapper}>
      <Component
        ref={itemRef}
        style={{ resize: 'none' }}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        name={name}
        showCount={showCount}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={e => {
          updatePosition?.(e.target.offsetTop)
          onFocus?.(e)
        }}
        onBlur={e => {
          updatePosition?.(0)
          onBlur?.(e)
        }}
        onPressEnter={onPressEnter}
        data-cy={name}
        autoSize={autoSize}
        className={clsx(className, {
          [s.errorBorder]: !!error
        })}
        data-id={dataId}
      />
      {supportingText && (
        <span
          className={clsx(s.helperText, {
            [s.error]: !!error
          })}
        >
          {supportingText}
        </span>
      )}
    </div>
  )
}
